<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import Introduction from "../components/home/Introduction.vue";
import { i18n, trainerDetails } from "../main.ts";
import PersologGalleria from "@persolog/ui/PersologGalleria.vue";
import { StartPageBannerItem } from "@persolog/utils";
import { LanguageManagementAPI } from "../api";

const trainer = trainerDetails;
const interfaceLanguage = computed(() => i18n.global.locale.value);

/**
 * The configured start-page banners (RDT-359). Language-management decides what is active and in its
 * display window; the galleria decides the audience and falls back to the bundled hero when this
 * stays empty, so a failing call costs the campaign, never the start page.
 */
const banners = ref<StartPageBannerItem[]>([]);

onMounted(async () => {
    try {
        banners.value = await LanguageManagementAPI.fetchStartPageBanners(interfaceLanguage.value);
    } catch (error) {
        console.error("Failed to fetch start page banners:", error);
        banners.value = [];
    }
});
</script>

<template>
    <MainMenu :trainer="trainer" skip-link-target="main-menu" />
    <PersologGalleria :banners="banners" :locale="interfaceLanguage" :trainer="trainer"></PersologGalleria>
    <Introduction />
    <Footer />
</template>
